import qs from 'qs';
export default function (params) {
  return qs.stringify(params, {
    arrayFormat: 'repeat'
  });
}